/* ============================================================
   WP Header
   - Predictive Search (Shopify /search/suggest.json)
   - Mobile Drawer (Burger → Side-Slide)
   - USP-Bar Mobile-Rotation
   - Sticky Shadow-Toggle
   - Cart-Badge Hook (Event-basiert + initial fetch)
   ============================================================ */
(function () {
  'use strict';

  var header = document.querySelector('[data-wp-header]');
  if (!header) return;

  // ----------------------------------------
  // 1. Predictive Search
  // ----------------------------------------
  var searchRoot   = header.querySelector('[data-wp-search]');
  var searchInput  = header.querySelector('[data-wp-search-input]');
  var searchClear  = header.querySelector('[data-wp-search-clear]');
  var predictive   = header.querySelector('[data-wp-predictive]');
  var resultsBox   = header.querySelector('[data-wp-predictive-results]');

  // Templates (aus snippets/wp-predictive-search.liquid)
  var tplCard      = document.querySelector('template[data-wp-tpl="result-card"]');
  var tplQuery     = document.querySelector('template[data-wp-tpl="query-link"]');
  var tplEmpty     = document.querySelector('template[data-wp-tpl="empty"]');
  var tplLoading   = document.querySelector('template[data-wp-tpl="loading"]');
  var tplHead      = document.querySelector('template[data-wp-tpl="section-head"]');

  var fetchToken = 0;
  var debounceId = null;

  function formatPrice(cents) {
    if (typeof cents !== 'number') return '';
    var euros = (cents / 100).toLocaleString('de-DE', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
    return euros + ' €';
  }

  function clearResults() {
    if (resultsBox) resultsBox.innerHTML = '';
  }

  function showPredictive(show) {
    if (!predictive) return;
    if (show) {
      predictive.hidden = false;
    } else {
      predictive.hidden = true;
    }
  }

  function renderHead(text) {
    if (!tplHead || !resultsBox) return;
    var node = tplHead.content.firstElementChild.cloneNode(true);
    node.textContent = text;
    resultsBox.appendChild(node);
  }

  function renderEmpty(query) {
    if (!tplEmpty || !resultsBox) return;
    var node = tplEmpty.content.firstElementChild.cloneNode(true);
    var q = node.querySelector('[data-wp-empty-query]');
    if (q) q.textContent = query;
    resultsBox.appendChild(node);
  }

  function renderLoading() {
    if (!tplLoading || !resultsBox) return;
    var node = tplLoading.content.firstElementChild.cloneNode(true);
    resultsBox.appendChild(node);
  }

  function renderProductCard(p) {
    if (!tplCard || !resultsBox) return;
    var node = tplCard.content.firstElementChild.cloneNode(true);
    node.href = p.url || '#';
    var imgEl = node.querySelector('img');
    if (imgEl && p.image) {
      imgEl.src = p.image;
      imgEl.alt = p.title || '';
    } else if (imgEl) {
      imgEl.remove();
    }
    var titleEl = node.querySelector('.wp-header__predictive-title');
    if (titleEl) titleEl.textContent = p.title || '';
    var priceEl = node.querySelector('.wp-header__predictive-price');
    if (priceEl) {
      priceEl.textContent = formatPrice(p.price);
    }
    resultsBox.appendChild(node);
  }

  function renderQueryLink(q) {
    if (!tplQuery || !resultsBox) return;
    var node = tplQuery.content.firstElementChild.cloneNode(true);
    node.href = '/search?q=' + encodeURIComponent(q.text || q) + '&type=product';
    var t = node.querySelector('.wp-header__predictive-query-text');
    if (t) t.textContent = q.text || q;
    resultsBox.appendChild(node);
  }

  function doSearch(query) {
    if (!query || query.length < 2) {
      clearResults();
      showPredictive(false);
      return;
    }

    var myToken = ++fetchToken;
    clearResults();
    renderLoading();
    showPredictive(true);

    var url = '/search/suggest.json'
      + '?q=' + encodeURIComponent(query)
      + '&resources[type]=product,query'
      + '&resources[limit]=5'
      + '&resources[options][unavailable_products]=last'
      + '&resources[options][fields]=title,product_type,variants.title,vendor';

    fetch(url, { headers: { 'Accept': 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (myToken !== fetchToken) return;

        clearResults();
        var products = (data.resources && data.resources.results && data.resources.results.products) || [];
        var queries  = (data.resources && data.resources.results && data.resources.results.queries)  || [];

        if (products.length === 0 && queries.length === 0) {
          renderEmpty(query);
          return;
        }

        if (products.length) {
          renderHead('Bücher');
          products.forEach(renderProductCard);
        }
        if (queries.length) {
          renderHead('Vorschläge');
          queries.forEach(renderQueryLink);
        }
      })
      .catch(function () {
        if (myToken !== fetchToken) return;
        clearResults();
        renderEmpty(query);
      });
  }

  if (searchInput) {
    searchInput.addEventListener('input', function () {
      var v = searchInput.value.trim();
      if (searchClear) searchClear.hidden = v.length === 0;
      clearTimeout(debounceId);
      debounceId = setTimeout(function () { doSearch(v); }, 220);
    });

    searchInput.addEventListener('focus', function () {
      if (searchInput.value.trim().length >= 2) showPredictive(true);
    });
  }

  if (searchClear) {
    searchClear.addEventListener('click', function () {
      if (!searchInput) return;
      searchInput.value = '';
      searchClear.hidden = true;
      clearResults();
      showPredictive(false);
      searchInput.focus();
    });
  }

  // Click outside → close
  document.addEventListener('click', function (e) {
    if (!searchRoot || !predictive) return;
    if (searchRoot.contains(e.target)) return;
    showPredictive(false);
  });

  // Escape → close
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      showPredictive(false);
      closeDrawer();
    }
  });

  // ----------------------------------------
  // 2. Mobile Drawer
  // ----------------------------------------
  var burger      = header.querySelector('[data-wp-burger]');
  var drawer      = document.querySelector('[data-wp-drawer]');
  var drawerCloses= document.querySelectorAll('[data-wp-drawer-close]');

  function openDrawer() {
    if (!drawer) return;
    drawer.hidden = false;
    // force reflow so transition kicks in
    void drawer.offsetWidth;
    drawer.setAttribute('data-open', '');
    document.body.classList.add('wp-header-drawer-open');
    if (burger) burger.setAttribute('aria-expanded', 'true');
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.removeAttribute('data-open');
    document.body.classList.remove('wp-header-drawer-open');
    if (burger) burger.setAttribute('aria-expanded', 'false');
    setTimeout(function () {
      if (!drawer.hasAttribute('data-open')) drawer.hidden = true;
    }, 320);
  }

  if (burger) burger.addEventListener('click', openDrawer);
  drawerCloses.forEach(function (el) {
    el.addEventListener('click', closeDrawer);
  });

  // ----------------------------------------
  // 3. USP-Bar Mobile-Rotation
  // ----------------------------------------
  var uspItems = header.querySelectorAll('[data-wp-usp-item]');
  if (uspItems.length > 1) {
    var idx = 0;
    setInterval(function () {
      uspItems[idx].removeAttribute('data-active');
      idx = (idx + 1) % uspItems.length;
      uspItems[idx].setAttribute('data-active', '');
    }, 3800);
  }

  // ----------------------------------------
  // 4. Sticky Shadow-Toggle
  // ----------------------------------------
  var stickyWrap = header.querySelector('[data-wp-sticky]');
  if (stickyWrap) {
    var uspBar = header.querySelector('.wp-header__uspbar');
    var threshold = uspBar ? uspBar.offsetHeight : 40;
    var rafId = null;
    function onScroll() {
      if (rafId) return;
      rafId = requestAnimationFrame(function () {
        rafId = null;
        var scrolled = window.scrollY > Math.max(threshold - 4, 4);
        header.classList.toggle('is-sticky', scrolled);
      });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // ----------------------------------------
  // 5. Cart-Badge Hook
  // ----------------------------------------
  var cartBadge = header.querySelector('[data-wp-cart-count]');

  function updateCartBadge(count) {
    if (!cartBadge) return;
    cartBadge.textContent = String(count);
    if (count > 0) {
      cartBadge.hidden = false;
    } else {
      cartBadge.hidden = true;
    }
  }

  // Listen for custom event from Funnel/PDP/Cart-Drawer
  window.addEventListener('wp:cart:updated', function (e) {
    var count = (e.detail && typeof e.detail.count === 'number') ? e.detail.count : 0;
    updateCartBadge(count);
  });

  // Optional initial sync on page load (covers cached pages where Liquid count is stale)
  if ('fetch' in window) {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (cart && typeof cart.item_count === 'number') {
          updateCartBadge(cart.item_count);
        }
      })
      .catch(function () { /* silent */ });
  }

})();